import React from "react";
import "./style.css"
function Brudcrumb({ title }) {
  return <h2 className="brudcrumb" style={{ marginTop: 0 }}>{title ? title : null}</h2>;
}

export default Brudcrumb;
